import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from '@helper/auth.guard';
import { Auth2Guard } from '@helper/auth2.guard';
import { ErrorPageComponent } from '@app/pages/error/error-page.component';
import { ComingSoonComponent } from './coming-soon/coming-soon.component';
import { APP_CONSTANTS } from '@app/_configs/constant';
import { LoginGuard } from '@app/_helpers/login.guard';
import { ComingSoonModule } from './coming-soon/coming-soon.module';

let routes: Routes;

if(!APP_CONSTANTS.IS_FRONT) {
  routes = [
  {
    path: 'coming-soon',
    component: ComingSoonComponent
  },
  {
    path: 'error',
    component: ErrorPageComponent
  },
  {
    path: '',
    loadChildren: () => import('./interface/interface.module').then(m => m.InterfaceModule),
    canActivate: [Auth2Guard]
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then(m => m.AuthModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'restaurant/:private_web_address',
    loadChildren: () => import('./store/store.module').then(m => m.StoreModule),
    canActivate: [LoginGuard]
  },
  {
    path: 'facing/:private_web_address',
    loadChildren: () => import('./facing/facing.module').then(m => m.StoreModule)
  },
  {
    path: 'error',
    component: ErrorPageComponent
  },
  {
    path: 'coming-soon',
    component: ComingSoonComponent
  },
  { 
    path: '**', 
    redirectTo: 'error',
    pathMatch: 'full'
  }];
} else {
  routes = [{
    path: '',
    loadChildren: () => import('./store/store.module').then(m => m.StoreModule)
  },
  {
    path: 'error',
    component: ErrorPageComponent
  },
  {
    path: 'coming-soon',
    component: ComingSoonComponent
  },
  { 
    path: '**', 
    redirectTo: 'error',
    pathMatch: 'full'
  }];
}

@NgModule({
  imports: [RouterModule.forRoot(routes), ComingSoonModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
